var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"w-7 text-EXPONDO-primary text-3xl iconify svg--grid"})}
var staticRenderFns = []

export { render, staticRenderFns }